import React from "react";
import { graphql } from "gatsby";
import Layout from "components/Layout";
import CareersView from "../ducks/Careers";

export default function Careers({ data }) {
  const cmsJobs = data?.cmsJobs?.edges?.map((e) => e.node.frontmatter) || [];
  return (
    <Layout title="Careers">
      <CareersView cmsJobs={cmsJobs} />
    </Layout>
  );
}

Careers.propTypes = {};

export const query = graphql`
  query CareersPageQuery {
    cmsJobs: allMarkdownRemark(
      filter: { fileAbsolutePath: { glob: "**/jobs/**" } }
    ) {
      edges {
        node {
          frontmatter {
            title
            slug
            uid
            jobLocation
            jobRemote
            jobBrand
            jobStartDate
            jobEndDate
          }
        }
      }
    }
  }
`;
